import { RoomType } from 'common/types'

// Rooms where the trainer's recording is paused (no recording happens there).
const PAUSE_ROOM_TYPES = new Set([RoomType.Lobby, RoomType.GroupRoom])
// Rooms that carry the `recording` param and are recorded.
const RECORDING_ROOM_TYPES = new Set([
	RoomType.TrainingRoom,
	RoomType.WebinarRoom,
])

export const isRecordingPauseRoom = (roomType?: RoomType): boolean =>
	!!roomType && PAUSE_ROOM_TYPES.has(roomType)

export const isRecordingRoom = (roomType?: RoomType): boolean =>
	!!roomType && RECORDING_ROOM_TYPES.has(roomType)
